export default function About() {
  return (
    <div className="relative py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="flex items-stretch gap-10">
          {/* Left side - Rotated title */}
          <div className="w-[35%] flex items-center justify-start">
            <h2
              className="font-bold text-gray-900 origin-center whitespace-nowrap"
              style={{
                fontSize: '72px',
                transform: 'rotate(-90deg)',
                transformOrigin: 'center center',
                width: '600px',
                marginLeft: '-200px'
              }}
            >
              ABOUT ELVIS DOO SABAC
            </h2>
          </div>

          {/* Right side - Cards */}
          <div className="w-[65%] flex gap-10">
            {/* First Card */}
            <div className="w-[45%] bg-gray-50 rounded-[32px] p-12 shadow-lg relative">
              <div className="absolute top-8 left-8 text-[180px] font-serif text-gray-900 opacity-10 leading-none">
                "
              </div>
              <p className="text-[28px] leading-tight text-gray-900 relative z-10 pt-24" style={{ fontFamily: 'Georgia, serif' }}>
                A team of experts developing modern applications for the iOS platform
              </p>
            </div>

            {/* Second Card */}
            <div className="w-[55%] bg-gray-50 rounded-[32px] p-12 shadow-lg">
              {/* Icon grid */}
              <div className="grid grid-cols-2 gap-8 mb-12">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full border-2 border-teal-500 flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-3xl text-teal-500"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">Security</span>
                </div>
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full border-2 border-teal-500 flex items-center justify-center mb-4">
                    <i className="ri-speed-line text-3xl text-teal-500"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">Performance</span>
                </div>
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full border-2 border-teal-500 flex items-center justify-center mb-4">
                    <i className="ri-lightbulb-line text-3xl text-teal-500"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">Innovation</span>
                </div>
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 rounded-full border-2 border-teal-500 flex items-center justify-center mb-4">
                    <i className="ri-user-heart-line text-3xl text-teal-500"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">User Experience</span>
                </div>
              </div>

              {/* Description text */}
              <p className="text-base font-light text-gray-700 leading-relaxed">
                Our expertise lies in creating high-quality iOS applications that prioritize user privacy, device performance, and seamless functionality. We combine technical excellence with innovative design to deliver products that truly enhance the mobile experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
